const APP_OPENED_TAB_KEY = "appOpenedTab";

export const openInAppTab = (url) => {
  const newTab = window.open("", "_blank");

  if (!newTab) {
    return false;
  }

  newTab.sessionStorage.setItem(APP_OPENED_TAB_KEY, "true");
  newTab.location.replace(url);

  return true;
};

export const wasOpenedInAppTab = () =>
  window.sessionStorage.getItem(APP_OPENED_TAB_KEY) === "true";
